const crossfadeDurationMs = 225;
const wrapper = "_35swnssiqv";
const toggle = "_35st136sm8o";
const transitionWrapper = "_35stuh0jmv";
const dropzoneContainer = "_35sdyy1zl";

export { crossfadeDurationMs, dropzoneContainer, toggle, transitionWrapper, wrapper };
import "./organism.facit-container.style.linaria.module.css";
//# sourceMappingURL=organism.facit-container.style.js.map
